import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import Sankey from "highcharts/modules/sankey";
import Organization from "highcharts/modules/organization";

import "./InvestorVisualizationModal.styles.scss";
import { useActionHook, useDidUpdate, useModals } from "hooks";
import { IInvestorVisualizationModal } from "store/types/modals";
// import hcMore from 'highcharts/highcharts-more';
import { useDealActions } from "store";
import { SimpleHead } from "components";

Sankey(Highcharts);
Organization(Highcharts);

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
};

const options = {
  chart: {
    height: 800,
    width: 1200,
    inverted: true
  },
  credits: {
    enabled: false
  },
  exporting: {},
  title: {
    text: ""
  },

  series: []
};

export const InvestorVisualizationModal: React.FC<IInvestorVisualizationModal> = ({ isOpen, dealId }) => {
  const { closeInvestorVisualizationModal } = useModals();
  const { getOrganizationGraphAction } = useDealActions();
  const { data, error, action } = useActionHook(getOrganizationGraphAction);
  // const { data, error } = useQueryHook(() => getOrganizationGraphAction(dealId || 1));

  useDidUpdate(() => {
    if (isOpen && dealId) {
      action(dealId);
    }
  }, [dealId]);

  const seriesData = {
    ...(data as any),
    name: "",
    levels: [
      {
        level: 0,
        color: "#7cb5ec",
        dataLabels: {
          color: "black"
        },
        height: 30
      },
      {
        level: 1,
        color: "#434348",
        dataLabels: {
          color: "white"
        },
        height: 30
      },
      {
        level: 2,
        color: "#980104",
        dataLabels: {
          color: "white"
        },
        height: 30
      }
    ],
    dataLabels: {
      enabled: true,
      useHTML: true,
      color: "black",
      style: {
        color: "black",
        fontSize: "10px",
        fontWeight: "bold"
      }
    }
  };

  const graph = { ...options, series: data && !error ? [seriesData] : [] };

  return (
    <Modal open={isOpen} onClose={closeInvestorVisualizationModal}>
      <Box sx={style}>
        <div>
          <SimpleHead onIconClick={closeInvestorVisualizationModal}>Investor visualization</SimpleHead>
          <HighchartsReact highcharts={Highcharts} options={graph} />
        </div>
      </Box>
    </Modal>
  );
};
